<!-- Assistant Recommendation toast (visible when panel is closed) -->
<!-- Promo variants when closed -->
<div *ngIf="!isOpen && promoStyle === 'toast' && showPromo" class="ai-reco-toast" role="button"
     aria-label="AI assistant recommendation" (click)="openFromBadge()" title="Open assistant insight">
  <div class="ai-reco-toast__avatar">
    <!-- avatar removed: 'AI' label intentionally hidden -->
    <span class="ai-reco-toast__pulse"></span>
  </div>
  <div class="ai-reco-toast__content" role="button" aria-label="Open AI assistant recommendation"
       (click)="openFromBadge()" tabindex="0">
    <div class="ai-reco-toast__title">Recommendation</div>
    <div class="ai-reco-toast__text">{{ primaryHighlight }}</div>
  </div>
  <button class="ai-reco-close" (click)="closePromo($event)" aria-label="Dismiss recommendation"
          title="Dismiss">
    ✕
  </button>
  <div class="ai-reco-toast__cta">Open ›</div>
</div>

<app-ai-reco-card *ngIf="!isOpen && promoStyle === 'card' && showPromo && !promoDismissed" [floating]="true"
                  [title]="'Insight for ' + reportName" [text]="primaryHighlight" (open)="openFromBadge()" (call)="emitCallAssistant()"
                  (dismiss)="closePromo($event)"></app-ai-reco-card>

<div *ngIf="isOpen"
     class="ai-panel"
     [class.ai-panel--open]="isOpen"
     [class.ai-panel--dock]="dockMode"
     [class.ai-panel--overlay]="!dockMode">
  <div class="ai-panel__header fancy">
    <div class="ai-panel__title">
      <!-- <div class="ai-panel__avatar"> -->
      <!-- rounded square avatar -->
      <!-- <div class="ai-panel__avatar-inner" aria-hidden="true"></div> -->
      <!-- </div> -->
      <div class="ai-panel__title-text">
        <div class="t1">Ledger AI</div>
        <div class="t2">{{ reportName }}</div>
      </div>
    </div>
    <div class="ai-panel__meta">
      <!-- <span class="pill" [ngClass]="statusClass" *ngIf="status">{{ status }}</span> -->
      <div class="spark" *ngIf="showCharts">
        <canvas baseChart [datasets]="headerSparkData" [labels]="headerSparkLabels" [options]="headerSparkOptions"
                [colors]="headerSparkColors" [legend]="false" [chartType]="headerSparkType"></canvas>
      </div>
      <!-- Call button removed; panel will be opened via the promo card and that click triggers the API. -->
      <button class="ai-panel__toggle" (click)="toggle()" title="Toggle AI assistant"
              aria-label="Toggle AI assistant">
        {{ isOpen ? '›' : '‹' }}
      </button>
    </div>
  </div>

  <div class="ai-panel__body" role="region" aria-label="AI assistant body" style="height: calc(100vh - 160px);">
    <!-- Large centered loader while waiting for AI response -->
    <div *ngIf="loading" class="ai-loading-large" aria-live="polite">
      <div #lottieContainer class="lottie-wrap">
        <!-- <img *ngIf="loading && !_lottieLoaded" src="/assets/img/ai-spinner.svg" alt="Loading" /> -->
      </div>
    </div>
    <!-- Top blurb (only show after response arrives) -->
    <div class="assistant-blurb" *ngIf="aiResponse && !loading && false">
      <div class="assistant-blurb__meta">Insight for {{ reportName }}</div>
      <div class="assistant-blurb__text">{{ truncateBeforeHash(aiResponse?.summary) }}</div>
    </div>

    <!-- assistant-checks block intentionally removed to hide detailed checks -->
    <!-- Suggestion cards at the bottom: either highlights or fallback examples -->
    <div class="assistant-suggestions" *ngIf="!loading">
      <div class="assistant-section-title">
        <div>Review Checks</div>
        <span style="font-weight: 400; font-size: 11px;">Approve each check before continuing.</span>
      </div>

      <div *ngIf="suggestionItems && suggestionItems.length; else fallbackSuggestions"
           style="overflow-y: auto;overflow-x: hidden;" [ngStyle]="{'max-height': (isApprovalMode && status == 'Awaiting Approval' && suggestionItems.length == approvedChecks.length) ?
        'calc(100vh - 387px)' : 'calc(100vh - 322px)', 'min-height': (isApprovalMode && status == 'Awaiting Approval' && suggestionItems.length == approvedChecks.length) ?
        'calc(100vh - 387px)' : 'calc(100vh - 322px)'}">
        <div class="suggestion-card" *ngFor="let s of suggestionItems"
             [class.suggestion-card--approved]="isApproved(s.id)"
             [class.suggestion-card--selected]="selectedSuggestionName === s.id" aria-label="Suggestion: {{ s.title }}">
          <div class="suggestion-card__icon">{{ s.emoji ? s.emoji : '🔎' }}</div>
          <div class="suggestion-card__body" (click)="onSelectSuggestion(s)" role="button" tabindex="0">
            <div class="suggestion-card__title">
              {{ s.name && s.name.length ? s.name : (s.title || 'Insight') }}
              <i style="width: 24px; height: 24px;" class="fa fa-info-circle tooltip-title" aria-hidden="true">
                <span class="tooltiptext">{{ s.checkedText }}</span>
              </i>
            </div>
          </div>
          <button *ngIf="isApprovalMode" class="suggestion-card__approve" title="Mark reviewed/approved"
                  (click)="toggleApprove(s, $event)" [attr.aria-pressed]="isApproved(s.id)">
            <span class="approve-icon">
              {{ isApproved(s.id) ? '✓' : '○' }}
            </span>
          </button>
        </div>
      </div>
      <ng-template #fallbackSuggestions>
        <div class="suggestion-card">
          <div class="suggestion-card__icon">🔎</div>
          <div class="suggestion-card__body">
            <div class="suggestion-card__title">No focused insights available</div>
            <div class="suggestion-card__desc">Try opening the assistant or run the analysis</div>
          </div>
        </div>
      </ng-template>

      <!-- fallback suggestions when no highlights provided -->
      <!-- <ng-container *ngIf="!highlights || highlights.length === 0">
        <div class="suggestion-card">
          <div class="suggestion-card__icon">📈</div>
          <div class="suggestion-card__body">
              <div class="suggestion-card__title">Volume up</div>
            <div class="suggestion-card__desc">Explore volume trend and drivers</div>
          </div>
          <div class="suggestion-card__badge">View</div>
        </div>
        <div class="suggestion-card">
          <div class="suggestion-card__icon">📎</div>
          <div class="suggestion-card__body">
            <div class="suggestion-card__title">24% of transactions missing docs</div>
            <div class="suggestion-card__desc">See suppliers with missing paperwork</div>
          </div>
          <div class="suggestion-card__badge">View</div>
        </div>
        <div class="suggestion-card">
          <div class="suggestion-card__icon">🗓️</div>
          <div class="suggestion-card__body">
            <div class="suggestion-card__title">72% of spend occurs on weekdays</div>
            <div class="suggestion-card__desc">Drill into weekday / weekend patterns</div>
          </div>
          <div class="suggestion-card__badge">View</div>
        </div>
      </ng-container> -->
    </div>
    <div *ngIf="isOpen && isApprovalMode && status=='Awaiting Approval'" class="approve-btn-container">
      <app-common-button
          [buttonText]="'Approve'"
          (buttonEvent)="openApproveModal()"
          [disabled]="approvedChecks.length != suggestionItems.length"
          [tooltip]="approvedChecks.length != suggestionItems.length ? 'Please review all checks before approving' : ''"
      ></app-common-button>
    </div>
  </div>
</div>
